function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { twMerge } from "tailwind-merge";
import cc from "classcat";
import { Bars3Icon, UserCircleIcon } from "@heroicons/react/24/solid";
import { DropdownMenuSeparator } from "@radix-ui/react-dropdown-menu";
import { ArrowDownTrayIcon, ArrowLeftOnRectangleIcon, BuildingOffice2Icon, QuestionMarkCircleIcon, UserCircleIcon as UserCircleIconDropdown } from "@heroicons/react/24/outline";
import SidebarTrigger from "../uikit/Sidebar/SidebarTrigger";
import Dropdown from "../uikit/Dropdown/Dropdown";
import DropdownTrigger from "../uikit/Dropdown/DropdownTrigger";
import DropdownContent from "../uikit/Dropdown/DropdownContent";
import DropdownItem from "../uikit/Dropdown/DropdownItem";
import Trans from "../intl/Trans";
import { authActions } from "../../redux/auth";
import routes from "../router/routes";
import useNavigate from "../../vendor/router/useNavigate";
import { myCompaniesActions, myCompaniesSelectors } from "../../redux/myCompanies";
import { useApplicationLoaderContext } from "./ApplicationLoaderContext";
import useFlashMessenger from "../../hooks/useFlashMessenger";
import { useTranslation } from "react-i18next";
import NavbarNotifications from "../notifications/NavbarNotifications";
import { Crisp } from "crisp-sdk-web";
import { configSelectors } from "../../redux/config";
import ReactSelect from "../uikit/Select/ReactSelect";
import { notificationsActions } from "../../redux/notifications";
import handleReportError from "../errors/handleReportError";
import { useResolvedPath } from "react-router-dom";
import { DEFAULT_NOTIFICATIONS_PER_PAGE, NOTIFICATIONS_FILTER_IS_READ } from "../notifications/utils";
import { operators } from "./utils";
export default function Navbar() {
    /**
     * --------------------
     * Handler for the logout dropdown option
     * --------------------
     */ var dispatch = useDispatch();
    var navigate = useNavigate();
    var resolvedPath = useResolvedPath();
    var setIsPageLoaderShown = useApplicationLoaderContext().setIsPageLoaderShown;
    var setErrorMessage = useFlashMessenger().setErrorMessage;
    var _useTranslation = useTranslation(), translate = _useTranslation.t;
    var crispWebsiteId = useSelector(configSelectors.crispWebsiteId);
    function onLogout() {
        return _onLogout.apply(this, arguments);
    }
    function _onLogout() {
        _onLogout = _async_to_generator(function() {
            var didLogout;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        /**
         * We trigger the logout api but we don't wait for it since it is not a critical flow.
         */ setIsPageLoaderShown(true);
                        return [
                            4,
                            dispatch(authActions.logoutApi())
                        ];
                    case 1:
                        didLogout = _state.sent();
                        //Daca logout din navbar raspunde cu eroare, afisam toaster si scoatem loaderul
                        if (!didLogout) {
                            setErrorMessage({
                                message: translate("common.logout.could-not-logout")
                            });
                            setIsPageLoaderShown(false);
                        } else {
                            navigate(routes.AUTH_LOGIN);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return _onLogout.apply(this, arguments);
    }
    function onGoToMyAccount() {
        navigate(routes.MY_ACCOUNT);
    }
    function onGoToMyCompanies() {
        navigate(routes.MY_COMPANIES);
    }
    /**
     * --------------------
     * Get the companies pairs and selected company from redux
     * --------------------
     */ var myCompaniesPairs = useSelector(myCompaniesSelectors.myCompaniesPairs);
    var selectedCompanyId = useSelector(myCompaniesSelectors.selectedCompanyId);
    var isLoadingCompaniesPairs = useSelector(myCompaniesSelectors.isLoadingCompaniesPairs);
    var myCompanies = myCompaniesPairs && myCompaniesPairs.length > 0 && myCompaniesPairs || [];
    //? nav needs to have z-[13] so the chat -using setZIndex(14)- is above it  (and the user sees the close button) - nav had z-50 before this
    return /*#__PURE__*/ React.createElement("nav", {
        className: "header sticky top-0 z-[13] flex flex-wrap items-center justify-between bg-white px-2 py-2 shadow dark:border-b-2 dark:border-blue-750 dark:bg-blue-800 dark:shadow-none lg:justify-end"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex items-center gap-x-3 text-2xl font-semibold"
    }, /*#__PURE__*/ React.createElement(SidebarTrigger, null, /*#__PURE__*/ React.createElement(Bars3Icon, {
        className: "h-10 w-10 text-black dark:text-gray-200"
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "flex items-center"
    }, myCompanies && /*#__PURE__*/ React.createElement("div", {
        className: "mr-6 block min-w-[150px] sm:mr-2"
    }, /*#__PURE__*/ React.createElement(ReactSelect, {
        name: "company",
        isLoading: isLoadingCompaniesPairs,
        className: "min-w-[150px] max-w-[150px] sm:min-w-[300px] sm:max-w-full",
        value: selectedCompanyId,
        items: myCompanies,
        itemToLabel: function(item) {
            return item.name;
        },
        itemToValue: function(item) {
            return item.id;
        },
        onChange: /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function(e) {
                var filters, e1;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            dispatch(myCompaniesActions.changeSelectedCompany(e.target.value));
                            if (!((resolvedPath === null || resolvedPath === void 0 ? void 0 : resolvedPath.pathname) === routes.DASHBOARD)) return [
                                3,
                                4
                            ];
                            filters = [
                                {
                                    field: NOTIFICATIONS_FILTER_IS_READ,
                                    operator: operators.EQ,
                                    value: false
                                }
                            ];
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                dispatch(notificationsActions.getNotifications({
                                    myCompanyId: e.target.value,
                                    page: 1,
                                    perPage: DEFAULT_NOTIFICATIONS_PER_PAGE,
                                    filters: filters
                                }))
                            ];
                        case 2:
                            _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 3:
                            e1 = _state.sent();
                            handleReportError(e1);
                            return [
                                3,
                                4
                            ];
                        case 4:
                            navigate(routes.DASHBOARD, null, null, true);
                            return [
                                2
                            ];
                    }
                });
            });
            return function(e) {
                return _ref.apply(this, arguments);
            };
        }(),
        renderActionItem: function() {
            return /*#__PURE__*/ React.createElement("div", {
                className: twMerge(cc([
                    "flex cursor-pointer select-none items-center justify-center gap-x-2"
                ]))
            }, /*#__PURE__*/ React.createElement(BuildingOffice2Icon, {
                className: "h-8 w-8"
            }), /*#__PURE__*/ React.createElement("span", null, /*#__PURE__*/ React.createElement(Trans, null, "layout.navbar.my-companies.list-link")));
        },
        onSelectActionItem: function() {
            return navigate(routes.MY_COMPANIES);
        }
    })), /*#__PURE__*/ React.createElement(NavbarNotifications, null), /*#__PURE__*/ React.createElement(Dropdown, null, /*#__PURE__*/ React.createElement(DropdownTrigger, {
        className: "group focus-visible:outline-none md:hover:cursor-pointer"
    }, /*#__PURE__*/ React.createElement("button", null, /*#__PURE__*/ React.createElement(UserCircleIcon, {
        className: "h-10 w-10 fill-blue-550 transition-all duration-300 hover:fill-blue-700 group-focus:fill-blue-700 group-data-[state=open]:fill-blue-700 dark:fill-gray-50 dark:hover:fill-gray-300 dark:group-focus:fill-gray-300 dark:group-data-[state=open]:fill-gray-300"
    }))), /*#__PURE__*/ React.createElement(DropdownContent, {
        className: "w-64",
        side: "bottom",
        align: "end",
        enhanceRoundedMd: true
    }, /*#__PURE__*/ React.createElement(DropdownItem, {
        onSelect: onGoToMyAccount
    }, /*#__PURE__*/ React.createElement(UserCircleIconDropdown, {
        className: "h-6 w-6 stroke-1 lg:h-8 lg:w-8"
    }), /*#__PURE__*/ React.createElement(Trans, null, "layout.navbar.my-account.my-account-link")), /*#__PURE__*/ React.createElement(DropdownItem, {
        onSelect: onGoToMyCompanies
    }, /*#__PURE__*/ React.createElement(BuildingOffice2Icon, {
        className: "h-6 w-6 stroke-1 lg:h-8 lg:w-8"
    }), /*#__PURE__*/ React.createElement(Trans, null, "layout.navbar.my-account.my-companies-link")), /*#__PURE__*/ React.createElement(DropdownItem, {
        onSelect: function() {
            return navigate(routes.MY_ACCOUNT_EXPORTS);
        }
    }, /*#__PURE__*/ React.createElement(ArrowDownTrayIcon, {
        className: "h-6 w-6 stroke-1 lg:h-8 lg:w-8"
    }), /*#__PURE__*/ React.createElement(Trans, null, "layout.navbar.exports")), /*#__PURE__*/ React.createElement(DropdownItem, {
        onSelect: function() {
            crispWebsiteId && Crisp.chat.show();
            crispWebsiteId && Crisp.chat.open();
        }
    }, /*#__PURE__*/ React.createElement(QuestionMarkCircleIcon, {
        className: "h-6 w-6 stroke-1 lg:h-8 lg:w-8"
    }), /*#__PURE__*/ React.createElement(Trans, null, "layout.sidebar.help-center.chat")), /*#__PURE__*/ React.createElement(DropdownMenuSeparator, {
        className: "my-2 border border-gray-300 dark:border-gray-500"
    }), /*#__PURE__*/ React.createElement(DropdownItem, {
        onSelect: onLogout
    }, /*#__PURE__*/ React.createElement(ArrowLeftOnRectangleIcon, {
        className: "h-6 w-6 stroke-1 lg:h-8 lg:w-8"
    }), /*#__PURE__*/ React.createElement(Trans, null, "layout.navbar.my-account.logout-link"))))));
}
